export const selectOptionsLoanProductType = [
  "DSCR",
  "Fix and Flip",
  // "Fix and Rent",
  "Ground Up Construction",
  "Stabilized Bridge",
  "Other",
];
